import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, Observable, of } from 'rxjs';
import { mapTo, tap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ConnectionService {

	online$: Observable<boolean>;
	isOnline$ = new BehaviorSubject<boolean>(false);

	constructor() {
		this.online$ = merge(
			of(navigator.onLine),
			fromEvent(window, 'online').pipe(mapTo(true)),
			fromEvent(window, 'offline').pipe(mapTo(false)),
		).pipe(
			tap((isOnline) => this.isOnline$.next(isOnline))
		);
	}
}
